const styles = {
  customPlayer: {
    display: 'none',
  },
  meditationContainer: {
    height: '100vh',
    width: '100vw',
    userSelect: 'none',
  },
  meditationButton: {
    height: '36px',
    zIndex: 2,
    cursor: 'pointer',
    userSelect: 'none',
    position: 'absolute',
    bottom: 'calc(50% - 18px)',
  },
  meditationButtonContainer: {
    position: 'absolute',
    left: 'calc(50% - 45px)',
    top: 'calc(50% - 45px)',
    borderRadius: '50%',
    border: '2px solid #fff',
    height: '86px',
    width: '86px',
  },
  meditationLogo: {
    position: 'absolute',
    height: '48px',
    top: '12px',
    '@media (max-width: 768px)': {
      left: '10%',
    },
    left: '111px',
  },
  meditationRadialGradient: {
    position: 'absolute',
    transform: 'rotate(-90deg)',
    bottom: 'calc(50% - 92px)',
    left: 'calc(50% - 92px)',
  },
  meditationLoadingRadialGradient: {
    strokeDasharray: 252,
  },
  meditationInfo: {
    position: 'absolute',
    '@media (max-width: 425px)': {
      left: 0,
    },
    left: 'calc(50% - 208px)',
    top: 'calc(50% - 220px)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    '& h6': {
      fontSize: '14px',
      fontWeight: 300,
      color: '#fff',
      margin: 0,
    },
    '& h3': {
      fontWeight: 300,
      fontSize: '30px',
      color: '#fff',
      margin: '0 0 10px 0',
      textAlign: 'center',
    },
  },
  meditationCurrentTime: {
    position: 'absolute',
    color: '#fff',
    fontWeight: 300,
    fontSize: '14px',
    bottom: '-58px',
    width: '100%',
    textAlign: 'center',
  },
};

export default styles;
